import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import MapConfigService from 'client/services/MapConfig/MapConfig.service';
const initialState = {
    result: null,
    loading: false,
    error: false
};

export const loadMapConfig = createAsyncThunk('mapConfig/loadMapConfig', (mapConfigId) => {
    // NOTE: loadMapConfig is also used in layersSlice and mapViewSlice
    // which means that their extraReducers also respond to the getMapConfig result
    return MapConfigService.getMapConfig(mapConfigId);
});

export const mapConfigReducer = createSlice({
    name: 'mapConfig',
    initialState: { ...initialState },
    extraReducers: {
        [loadMapConfig.pending]: state => {
            return {
                ...state,
                loading: true,
                error: false
            };
        },
        [loadMapConfig.fulfilled]: (state, action) => {
            return {
                result: action.payload,
                loading: false,
                error: false
            };
        },
        [loadMapConfig.rejected]: () => {
            return {
                result: null,
                loading: false,
                error: true
            };
        }
    }
});

export default mapConfigReducer.reducer;
